(function () {
  var selectors = {
    component: '[data-zr-bundle-progress]',
    eligibleItem: '[data-zr-bundle-eligible="true"]',
    quantity: '.js-qty__num'
  };

  function quantityFor(component) {
    // The separate bundle page receives its count from Shopify's cart render.
    if (component.hasAttribute('data-zr-bundle-eligible-count')) {
      return Math.max(0, parseInt(component.dataset.zrBundleEligibleCount, 10) || 0);
    }
    var form = component.closest('form');
    if (!form) return 0;

    return Array.prototype.reduce.call(form.querySelectorAll(selectors.eligibleItem), function (total, item) {
      return total + (parseInt(item.dataset.zrBundleQuantity, 10) || 0);
    }, 0);
  }

  function offerFor(quantity) {
    var message = 'Add eligible prints to unlock bundle savings.';
    if (quantity >= 10) message = '10+ print tier: 30% off eligible prints.';
    else if (quantity >= 8) message = '25% bundle tier reached. Add ' + (10 - quantity) + ' more to unlock 30%.';
    else if (quantity >= 6) message = '20% bundle tier reached. Add ' + (8 - quantity) + ' more to unlock 25%.';
    else if (quantity >= 4) message = '15% bundle tier reached. Add ' + (6 - quantity) + ' more to unlock 20%.';
    else if (quantity === 3) message = '10% bundle tier reached. Add 1 more to unlock 15% off.';
    else if (quantity === 2) message = '5% bundle tier reached. Add 1 more to unlock 10%.';
    else if (quantity === 1) message = 'Add 1 more eligible print to unlock 5% off.';
    return { width: Math.min(quantity, 10) * 10, message: message };
  }

  function update(component) {
    var quantity = quantityFor(component);
    var offer = offerFor(quantity);
    var count = component.querySelector('[data-zr-bundle-count]');
    var bar = component.querySelector('[data-zr-bundle-progress-bar]');
    var message = component.querySelector('[data-zr-bundle-message]');

    var countText = quantity + (quantity === 1 ? ' eligible print' : ' eligible prints');
    if (count && count.textContent !== countText) count.textContent = countText;
    if (bar) bar.style.width = offer.width + '%';
    if (message && message.textContent !== offer.message) message.textContent = offer.message;
    component.querySelectorAll('[data-zr-tier-min]').forEach(function (tile) {
      tile.classList.toggle('is-reached', quantity >= Number(tile.dataset.zrTierMin));
    });
  }

  function updateAll() {
    Array.prototype.forEach.call(document.querySelectorAll(selectors.component), update);
  }

  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('cart:build', function () { window.setTimeout(updateAll, 0); });
  document.addEventListener('cart:quantity', function () { window.setTimeout(updateAll, 0); });
  document.addEventListener('change', function (event) {
    if (event.target.matches(selectors.quantity)) window.setTimeout(updateAll, 0);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-products]').forEach(function (container) {
      new MutationObserver(updateAll).observe(container, {childList: true, subtree: true});
    });
  });
}());
